import { useCacheStore } from "src/stores/cacheStore"
import {
  AttributeBase,
  AttributeChar,
  AttributeNumeric,
  AttributeSelect,
  AttributeSelectOptions,
  AttributeTemporal,
} from "src/util/types/dataModels/attribute"

export function isAttributeChar(attribute: AttributeBase): attribute is AttributeChar {
  return (
    (attribute as AttributeChar).autocomplete !== undefined &&
    (attribute as AttributeChar).allow_blank !== undefined
  )
}

export function isAttributeNumeric(attribute: AttributeBase): attribute is AttributeNumeric {
  return (attribute as AttributeNumeric).decimals !== undefined
}

export function isAttributeTemporal(attribute: AttributeBase): attribute is AttributeTemporal {
  return (
    (attribute as AttributeTemporal).enable_date !== undefined &&
    (attribute as AttributeTemporal).enable_time !== undefined
  )
}

export function isAttributeSelect(attribute: AttributeBase): attribute is AttributeSelect {
  return (attribute as AttributeSelect).allow_multiple_selections !== undefined
}

export function isAttributeSelectOption(attribute: unknown): attribute is AttributeSelectOptions {
  return (attribute as AttributeSelectOptions).value !== undefined
}

export function attributeSelectToString(options: string[]) {
  if (options.length === 0) return null

  const values = []

  const cacheStore = useCacheStore()

  for (const opt of options) {
    const cachedOption = cacheStore.attribute_select_options.get(opt)
    if (cachedOption) values.push(cachedOption.value)
  }

  return values.join(", ")
}

export function attributeTemporalToString(date: string | null, time: string | null): string | null {
  if (date && time) {
    return date + " " + time
  } else if (date) {
    return date
  } else if (time) {
    return time
  } else {
    return null
  }
}
